import uploadRoutes from "./storage/routes";

import { IRoute, RenderRoutes } from "@src/routes";

const routes: IRoute[] = [
  {
    menu: { label: "Usuários SSO" },
    path: "/upload",
    key: "UP",
    component: (props: any) => <RenderRoutes {...props} />,
    routes: [
      {
        path: "/upload/",
        key: "UP_ROOT",
        exact: true,
        component: () => null,
      },
      ...uploadRoutes,
    ],
  },
];

export default routes;
